import React from 'react';

const SectionTitle = ({title}) => (
   
                <div className="section-title">{title}</div>
      
)

export default SectionTitle